<div class="select-account-wrapper" *ngIf="currentAccount">
  <form [formGroup]="currentAccount" *ngIf="accounts && accounts.length > 0">
    <frg-form-input
      label="Sélectionnez un compte"
      [formGroup]="currentAccount"
      type="ngSelect"
      [selectValue]="accounts"
      id="accountName"
      [control]="currentAccount.get('accountName')"
      required="true"
      errorMessage="Veuillez sélectionner un compte"
      [isClearableSelect]="false"
    ></frg-form-input>
    <div class="buttons-wrapper center">
      <frg-button type="button" (activated)="selectAccount(true)" [disabled]="!currentAccount.valid" fullWidth="true">Relever le courrier</frg-button>
    </div>
    <div class="buttons-wrapper center">
      <frg-button type="button" (activated)="selectAccount(false)" [disabled]="!currentAccount.valid" fullWidth="true">Valider</frg-button>
    </div>
  </form>

  <div class="buttons-wrapper center connect-with-mailiz">
    <frg-button type="button" (activated)="connectWithMailiz()" fullWidth="true">Ajouter un compte Mailiz</frg-button>
  </div>
</div>

<div class="page-wrapper" *ngIf="accountSelected && !mustReleverCourrier" [ngClass]="{ 'extend-message-zone': isExtendMessageZone }">
  <div class="no-mss-settings" *ngIf="!isMSSSet">
    <div class="wording">Les paramètres pour l'envoi de piece jointes ne sont pas paramétrés veuillez les renseigner dans les options</div>
    <frg-button (activated)="goToMSSSettings()">Paramètres DMP/MSS</frg-button>
  </div>

  <div class="search-wrapper" *ngIf="isMSSSet && isConnected && folders && folders.length > 0">
    <form (ngSubmit)="doSearchMessage()" *ngIf="searchFormGroup">
      <frg-form-input
        label="Recherche"
        [formGroup]="searchFormGroup"
        id="plainText"
        [control]="searchFormGroup.get('plainText')"
        errorMessage=""
      ></frg-form-input>
      <frg-button (activated)="doSearchMessage()" [disabled]="!searchFormGroup.valid" fullWidth="true">Rechercher</frg-button>
    </form>
  </div>

  <div class="mail-box-wrapper" *ngIf="isMSSSet && isConnected && folders && folders.length > 0">
    <div class="folders-wrapper">

      <div class="buttons-wrapper text-buttons">
        <frg-button fullWidth="true" (activated)="refresh()" [disabled]="refreshing">
          <div class="icon refresh" [ngClass]="{ 'loading': refreshing }">Rafraîchir</div>
        </frg-button>
        <frg-button fullWidth="true" (activated)="createMessage()">
          <div class="icon add">Nouveau mail</div>
        </frg-button>
      </div>

      <mat-tree *ngIf="treeControl" #treeSelector [dataSource]="dataSource" [treeControl]="treeControl">
        <mat-tree-node *matTreeNodeDef="let node" matTreeNodeToggle class="foler-name"
          cdkDropList [id]="'folder_' + node.folderId"
          [cdkDropListConnectedTo]="'messagesList'" (cdkDropListDropped)="dropMessage($event)"
          (click)="searchMessages(node.folderId, node)"
          [ngClass]="{ 'selected-item': node.folderId === selectedFolderId }"
          [ngStyle]="{'margin-left': getNodeMargin(node)}">

          <button mat-icon-button matTreeNodeToggle [attr.aria-label]="'Toggle ' + node.name" [ngStyle]="{ 'visibility': node.expandable ? 'unset' : 'hidden' }">
            <mat-icon>{{ treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right' }}</mat-icon>
          </button>
          {{ node.name }}

          <div class="icon-more-container" *ngIf="canCreateFolder || canRenameFolder || canRemoveFolder">
            <button mat-icon-button [matMenuTriggerFor]="menu" (click)="$event.stopPropagation()">
              <div class="icon-more"></div>
            </button>
            <mat-menu #menu="matMenu">
              <button mat-menu-item (click)="createFolder(node.folderId)" *ngIf="canCreateFolder">
                <span>Ajouter un dossier</span>
              </button>
              <button mat-menu-item (click)="renameFolder(node.folderId)" *ngIf="canRenameFolder">
                <span>Renommer le dossier</span>
              </button>
              <button mat-menu-item (click)="deleteFolder(node.folderId)" *ngIf="canRemoveFolder">
                <span class="delete">Supprimer le dossier</span>
              </button>
            </mat-menu>
          </div>
        </mat-tree-node>
      </mat-tree>
    </div>

    <div class="messages-list">
      <div class="loader-wrapper" *ngIf="areMessagesLoading">
        <div class="lds-spinner">
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
          <div></div>
        </div>
      </div>

      <ng-container *ngIf="messagesDisplay && messagesDisplay.length > 0 && !areMessagesLoading">
        <span cdkDropList id="messagesList" [cdkDropListConnectedTo]="listFoldersToDrop" [cdkDropListData]="messagesDisplay">
          <div class="message-line" cdkDrag
          *ngFor="let message of messagesDisplay"
          (click)="showMessage(message.messageId)"
          [ngClass]="{ 'selected-item': message.messageId === selectedMessageId }">
          <div class="message-attachment-icon">
            <div class="icon" *ngIf="message.attachments && message.attachments.length > 0"></div>
          </div>
          <div class="message-infos" [ngClass]="{ 'bolder': message.flags && message.flags.includes(mssEnumFlag.UNREAD) }">
            <div class="message-meta">
              <div class="message-subject">{{ message.subject }}</div>
              <div class="message-date">{{ getMessageDate(message) | date: 'dd/MM/yyyy' }}</div>
            </div>
            <div class="message-meta">
              <div class="message-sender">{{ getMessageSender(message) }}</div>
              <div class="message-date">{{ getMessageDate(message) | date: 'HH:mm' }}</div>
            </div>
          </div>
        </div>
      </span>

        <frg-button fullWidth="true" (activated)="getNextMessages()" [disabled]="noMoreMessageForFolder || isNextMessageLoading">
          <div *ngIf="!isNextMessageLoading">Messages suivants</div>
          <div *ngIf="isNextMessageLoading" class="lds-spinner">
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
            <div></div>
          </div>
        </frg-button>
      </ng-container>

      <ng-container *ngIf="(!messagesDisplay || messagesDisplay.length === 0) && !areMessagesLoading">
        <div class="no-message" *ngIf="!selectedFolderId">Aucun dossier sélectionné</div>
        <div class="no-message" *ngIf="selectedFolderId">Aucun message</div>
      </ng-container>
    </div>

    <div class="message-content">
      <app-mss-message-display
        *ngIf="selectedMessage"
        [message]="selectedMessage"
        [balSender]="userMail"
        [idNat]="selectedIdNat"
        (doDownloadAttachment)="downloadAttachment($event)"
        (doAddAttachmentToPatient)="addAttachmentToPatient($event)"
        (doDeleteMessage)="deleteMessage($event)"
        (doSaveDraft)="saveDraft($event)"
        (doSendMessage)="sendMessage($event)"
        (doExtend)="doExtendMessage($event)"
        (doUnselectMessage)="unselectMessage($event)"
      ></app-mss-message-display>
    </div>
  </div>

  <div class="no-mail-wrapper" *ngIf="isMSSSet && isConnected && (!folders || folders.length === 0)">
    <div class="wording">Aucun message à afficher</div>
  </div>
</div>
